import { createSlice } from "@reduxjs/toolkit";
import { AdditionalRequestState } from "../dataTypes";
import { fileSliceName } from "./dataTypes";
import { fileAdapter } from "./fileAdapter";
import { addFetchFilesForPageContentReducers } from "./reducers/fetchFilesForPageContent";

const slice = createSlice({
  name: fileSliceName,
  initialState: fileAdapter.getInitialState<AdditionalRequestState>({}),
  reducers: {},
  extraReducers: builder => {
    addFetchFilesForPageContentReducers(builder);
  },
});

const { reducer } = slice;

export default reducer;
